import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BoardActorsSection from '../components/corporate/board-actors-section';
export default connect(state => ({
  countries: state.countries.fetch
}), dispatch => bindActionCreators({}, dispatch))(BoardActorsSection);